import { axiosApi } from "./helper";

export function getOneHRCategories(obj) {
  return axiosApi("categories_onehr", obj, "get");
}
